const { default: useDialog } = require("./useDialog")

// The useYesOrNo is a wrapper around the dialog hook intended to normalize the way we use
// confirmation dialogs across the application.
const useYesOrNo = (uniqueDialogName, options={ params: {} }) => {
  return useDialog('yes_or_no', uniqueDialogName, options)
}

export default useYesOrNo
